module.exports = __webpack_public_path__ + "static/media/myphoto.18792f67.JPG";